import React, { useState } from "react";

interface ReportArticleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (reason?: string) => Promise<void>;
  articleTitle: string;
}

const ReportArticleModal: React.FC<ReportArticleModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  articleTitle,
}) => {
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await onSubmit(reason || undefined);
      setReason("");
      onClose();
    } catch (error) {
      console.error("Failed to submit report:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setReason("");
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">
            Zgłoś problem z artykułem
          </h2>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">Artykuł:</p>
            <p className="text-sm font-medium text-gray-900 line-clamp-2">
              {articleTitle}
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="reason"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Powód zgłoszenia (opcjonalnie)
              </label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                maxLength={500}
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="Opisz problem z tym artykułem..."
                disabled={isSubmitting}
              />
              <p className="text-xs text-gray-500 mt-1">
                {reason.length}/500 znaków
              </p>
            </div>

            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={handleCancel}
                disabled={isSubmitting}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Anuluj
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Wysyłanie..." : "Wyślij zgłoszenie"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReportArticleModal;
